module.exports = __webpack_public_path__ + "media/images/flags/gt-372656ecd2e15b6c70bf91024f06d8df.svg";